import { defineMessages } from 'react-intl'

const scope = `procurify.components.CountrySelect`

export default defineMessages({
  selectPlaceholderText: {
    id: `${scope}.selectPlaceholderText`,
    defaultMessage: 'Select a country',
  },
})
